import _extend from "lodash/extend";
import eventEmitterMixin from "web/script/mixins/event-emitter";

export default _extend({}, eventEmitterMixin);
